import { SPORT } from './sport'

export const TABLE_TENNIS_LICENSE_SPORT = 'tabletennis'

export const FORMATTED_LICENSE_SPORTS = [
  SPORT.AMERICAN_FOOTBALL,
  SPORT.BASKETBALL,
  SPORT.CRICKET,
  SPORT.GOLF,
  SPORT.ICE_HOCKEY,
  SPORT.MMA,
  SPORT.SNOOKER,
  SPORT.SOCCER,
  TABLE_TENNIS_LICENSE_SPORT,
  SPORT.TENNIS,
  SPORT.VOLLEYBALL
] as const

export type FormattedLicenseSport = (typeof FORMATTED_LICENSE_SPORTS)[number]

type LicensePropertyObject = {
  label: string
  value: string
  sport: FormattedLicenseSport | ''
  endpoint: string
}

export const MSFP_LICENSE_PROPERTY_PLACEHOLDER_OBJECT: LicensePropertyObject = {
  label: 'Select Property',
  value: 'no_property_selected',
  sport: '',
  endpoint: ''
}

export const NO_SEASON_DATA_TEXT = 'No season data for this period'

export const MSFP_LICENSE_PROPERTY_OBJECTS: LicensePropertyObject[] = [
  MSFP_LICENSE_PROPERTY_PLACEHOLDER_OBJECT,
  { label: 'Soccer Core', value: 'SOCCER_CORE', sport: SPORT.SOCCER, endpoint: SPORT.SOCCER },
  {
    label: 'Mediafeed Soccer',
    value: 'MEDIAFEED_SOCCER',
    sport: SPORT.SOCCER,
    endpoint: SPORT.SOCCER
  },
  {
    label: 'Soccer PNB Tracking',
    value: 'SOCCER_PNB_TRACKING',
    sport: SPORT.SOCCER,
    endpoint: SPORT.SOCCER
  },
  {
    label: 'Soccer Core OB GameState',
    value: 'SOCCER_CORE_OB_GAMESTATE',
    sport: SPORT.SOCCER,
    endpoint: SPORT.SOCCER
  },
  {
    label: 'Basketball Core',
    value: 'BASKETBALL_CORE',
    sport: SPORT.BASKETBALL,
    endpoint: SPORT.BASKETBALL
  },
  {
    label: 'Basketball Euroleague',
    value: 'BASKETBALL_EUROLEAGUE',
    sport: SPORT.BASKETBALL,
    endpoint: SPORT.BASKETBALL
  },
  {
    label: 'American Football Core',
    value: 'AMERICAN_FOOTBALL_CORE',
    sport: SPORT.AMERICAN_FOOTBALL,
    endpoint: SPORT.AMERICAN_FOOTBALL
  },
  {
    label: 'Table Tennis Core',
    value: 'TABLETENNIS_CORE',
    sport: TABLE_TENNIS_LICENSE_SPORT,
    endpoint: `v2/${TABLE_TENNIS_LICENSE_SPORT}`
  },
  {
    label: 'Volleyball Core',
    value: 'VOLLEYBALL_CORE',
    sport: SPORT.VOLLEYBALL,
    endpoint: `v2/${SPORT.VOLLEYBALL}`
  },
  { label: 'Snooker Core', value: 'SNOOKER_CORE', sport: SPORT.SNOOKER, endpoint: SPORT.SNOOKER },
  { label: 'Cricket Core', value: 'CRICKET_CORE', sport: SPORT.CRICKET, endpoint: SPORT.CRICKET },
  { label: 'Soccer Pricing', value: 'SOCCER_PRICING', sport: SPORT.SOCCER, endpoint: SPORT.SOCCER },
  {
    label: 'Mediafeed Basketball',
    value: 'MEDIAFEED_BASKETBALL',
    sport: SPORT.BASKETBALL,
    endpoint: SPORT.BASKETBALL
  },
  {
    label: 'Mediafeed Snooker',
    value: 'MEDIAFEED_SNOOKER',
    sport: SPORT.SNOOKER,
    endpoint: SPORT.SNOOKER
  }
]

export const USE_COMPETITIONS = {
  ALL: 'COMPETITIONS_ALL',
  PARTIAL: 'COMPETITIONS_PARTIAL'
} as const

export type UseCompetitionsType = (typeof USE_COMPETITIONS)[keyof typeof USE_COMPETITIONS]
